import { Icon } from '@assembly-js/design-system';
import clsx from 'clsx';

interface StudioAuthLogoProps {
  className?: string;
}

/** Shared 32×32 black-tile Assembly mark for Studio auth screens. */
export const StudioAuthLogo = ({ className }: StudioAuthLogoProps) => (
  <div
    className={clsx(
      'flex h-8 w-8 shrink-0 items-center justify-center rounded-[8px] bg-black',
      className,
    )}
  >
    <Icon icon="AssemblyLogo" className="h-[18px] w-[18px] text-white" />
  </div>
);
